import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import messages from './i18n'

const i18n = createI18n({
  legacy: false, // 使用 Composition API
  locale: 'zh', // 设置默认语言
  fallbackLocale: 'en', // 设置备用语言
  messages
})

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')